import { apiClient } from '../client';
import { API_ENDPOINTS, CACHE_CONFIG } from '../config';

interface InsuranceProvider {
  id: string;
  name: string;
  logoUrl: string;
  plans: string[];
}

interface VerifyInsuranceData {
  providerId: string;
  memberId: string;
  dateOfBirth: string;
}

class InsuranceService {
  async getInsuranceProviders(): Promise<{ success: boolean; data: InsuranceProvider[] }> {
    return apiClient.get(API_ENDPOINTS.insurance.providers, {
      cacheTTL: CACHE_CONFIG.staticDataTTL
    });
  }

  async verifyInsurance(data: VerifyInsuranceData) {
    return apiClient.post(API_ENDPOINTS.insurance.verify, data);
  }
}

export const insuranceService = new InsuranceService();